const faqs = [
  {
    id: 1,
    q: '黑料吃瓜网的内容来源可靠吗？',
    a: '黑料吃瓜网的内容均来自公开网络渠道整理与用户投稿，我们会对每条黑料爆料进行多方交叉验证后再发布。对于尚未确认的信息，我们会明确标注"传闻"或"待核实"，绝不为了流量传播未经证实的谣言。黑料吃瓜在线内容更新前均经过编辑团队审核。',
  },
  {
    id: 2,
    q: '黑料吃瓜不打烊是什么意思？',
    a: '"黑料吃瓜不打烊"是我们对吃瓜群众的承诺——平台保持 24 小时不间断更新。无论深夜还是节假日，我们的黑料爆料团队始终在线追踪最新热点，确保你随时打开都能看到新鲜的黑料吃瓜视频和吃瓜黑料合集。',
  },
  {
    id: 3,
    q: '如何向黑料吃瓜网投稿爆料？',
    a: '欢迎通过页面的"投稿爆料"入口向我们提供线索。请在投稿时尽量附上相关截图、链接或视频等佐证材料，我们的编辑团队会在收到投稿后 24 小时内进行审核评估。所有投稿者信息严格保密，黑料最新爆料将优先推送给全体吃瓜群众。',
  },
  {
    id: 4,
    q: '黑料吃瓜在线观看视频需要付费吗？',
    a: '完全不需要。黑料吃瓜网所有内容均为免费浏览，包括黑料吃瓜在线观看视频、深度扒皮文章和吃瓜黑料合集。我们依靠广告和品牌合作维持运营，绝不向吃瓜群众收取任何费用。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              常见问答
            </h2>
          </div>

          <div className="space-y-3">
            {faqs.map((faq) => (
              <details
                key={faq.id}
                className="group bg-background-100 border border-background-200/60 rounded-lg overflow-hidden"
              >
                <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                  <h3 className="text-sm font-semibold text-foreground-800 pr-6">
                    {faq.q}
                  </h3>
                  <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                    <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                  </span>
                </summary>
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm leading-relaxed text-foreground-600 border-t border-background-200/60 pt-4">
                    {faq.a}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}